import { PLACEHOLDERS } from '@/lib/placeholders';

type BrandLogoProps = {
  className?: string;
  /** Tailwind text-* color drives the mark via currentColor */
  title?: string;
};

/**
 * Themeable Bazaarak mark — black silhouette PNG as mask, colored with currentColor.
 * Examples: `text-stone-900`, `text-white`, `text-gold`
 */
export default function BrandLogo({
  className = 'w-10 h-10',
  title = 'Bazaarak',
}: BrandLogoProps) {
  return (
    <span
      role="img"
      aria-label={title}
      className={`inline-block shrink-0 align-middle ${className}`}
      style={{
        backgroundColor: 'currentColor',
        WebkitMaskImage: `url(${PLACEHOLDERS.logoMark})`,
        maskImage: `url(${PLACEHOLDERS.logoMark})`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
    />
  );
}
